/* eslint-disable camelcase */
import React, { useEffect, useState, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { get } from 'lodash';
import { toast } from 'react-toastify';
import { Button, Box } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import StringMask from 'string-mask';
import { ContainerGrid, Title } from '../../styles/GlobalStyles';
import axios from '../../services/axios';
import Loading from '../../components/Loading';
import DataTable from '../../components/DataTable';

const textData = 'Empresas';
const tableRoute = 'empresa';
const tableData = 'empresas';

export default function Cadastro() {
  const [table, setTable] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    async function getData() {
      try {
        setIsLoading(true);
        const response = await axios.get(`/${tableData}`);
        setTable(response.data);
      } catch (err) {
        const status = get(err, 'response.status', 0);
        const errors = get(err, 'response.data.errors', []);

        if (status === 400) errors.map((error) => toast.error(error));
        navigate(`/home`);
      } finally {
        setIsLoading(false);
      }
    }
    getData();
  }, [navigate]);

  const columns = useMemo(
    () => [
      {
        accessorKey: 'id', // access nested data with dot notation
        header: 'ID',
        size: 80,
        hidden: true,
      },
      {
        accessorKey: 'nome',
        header: 'Nome',
        size: 110,
      },
      {
        accessorKey: 'fantasia',
        header: 'Nome Fantasia',
        size: 80,
      },
      {
        accessorKey: 'cnpj',
        accessorFn: (row) =>
          new StringMask('00.000.000/0000-00').apply(row.cnpj),
        header: 'CNPJ',
        size: 80,
      },
    ],
    []
  );

  return (
    <ContainerGrid>
      <Title>{`${textData}`}</Title>
      <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
        <Button
          type="button"
          color="secondary"
          variant="contained"
          onClick={() => navigate(`/${tableRoute}`)}
        >
          <AddIcon size={24} />
        </Button>
        <Button
          type="button"
          color="secondary"
          variant="contained"
          style={{ marginLeft: '5px' }}
          onClick={() => navigate(`/home`)}
        >
          Fechar
        </Button>
      </Box>
      <div>
        <DataTable
          columns={columns}
          data={table}
          tableData={tableData}
          tableRoute={tableRoute}
        />
      </div>
      <Loading isLoading={isLoading} />
    </ContainerGrid>
  );
}
